import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'app-layer-preview-modal',
	templateUrl: './layer-preview-modal.component.html',
	styleUrls: ['./layer-preview-modal.component.css']
})
export class LayerPreviewModalComponent implements OnInit {
	@ViewChild('table', { static: false }) table;
	public previewRows: any[] = [];
	public previewColumns: any[] = [];

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public dialogRef: MatDialogRef<LayerPreviewModalComponent>
	) { }

	ngOnInit() {
		this.previewRows = this.data.previewRows;
		this.previewColumns = this.data.previewColumns;
		// setTimeout(() => {
		// 	this.table.resize();
		// });
	}

}

